



















































































































import {
  Component,
  Vue,
  Prop,
  PropSync,
  Watch,
  Ref,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import AuthSecurityCode from '@/components/Auth/AuthSecurityCode.vue';
import AuthErrorAlert from '@/components/Auth/AuthErrorAlert.vue';
import AuthResendBtn from '@/components/Auth/AuthResendBtn.vue';

@Component({
  components: {
    AuthSecurityCode,
    AuthErrorAlert,
    AuthResendBtn,
  },
  computed: {
    ...mapState('Business', {
      business: 'business',
    }),
  },
})
export default class BusinessVerifyContactForm extends Vue {
  @PropSync('verifyContact', { default: {} }) verifyContactSync!: Model;
  @Prop({ default: 'email' }) verifyItem!: string;
  @PropSync('showVerifyDialog', { default: false })
  showVerifyDialogSync!: boolean;
  @Ref() readonly authSecurityCode!: { focusCodeInput: () => void };

  business!: Model;

  verifyErrors = {};

  isSendingCode = false;
  isVerifying = false;
  isSentCode = false;
  resendTime = 29;

  reload = 0;

  @Watch('showVerifyDialogSync')
  watchBusiness(v) {
    if (v) {
      this.verifyErrors = {};
      this.isSentCode = false;
      this.reload++;
      this.resendTime = 29;
    }
  }

  sendVerifyEmailTotp() {
    this.verifyErrors = {};
    this.verifyContactSync.email_totp = '';
    if (this.authSecurityCode) {
      this.authSecurityCode.focusCodeInput();
    }
    this.isSendingCode = true;
    return this.$store
      .dispatch('BusinessContact/sendVerifyEmailTotp', this.verifyContactSync)
      .then(() => {
        this.isSendingCode = false;
        this.isSentCode = true;
      });
  }

  sendVerifyMobileTotp() {
    this.verifyErrors = {};
    this.verifyContactSync.mobile_totp = '';
    if (this.authSecurityCode) {
      this.authSecurityCode.focusCodeInput();
    }
    this.isSendingCode = true;
    return this.$store
      .dispatch('BusinessContact/sendVerifyMobileTotp', this.verifyContactSync)
      .then(() => {
        this.isSendingCode = false;
        this.isSentCode = true;
      })
      .catch(({ response }) => {
        this.isSentCode = true;
        this.isSendingCode = false;
        this.resendTime = 0;
        this.verifyErrors = response.data.error;
        return Promise.reject();
      });
  }

  verify(attribute = 'email') {
    let totp = '';
    if (attribute == 'email') {
      totp = this.verifyContactSync.email_totp;
    } else {
      totp = this.verifyContactSync.mobile_totp;
    }
    if (totp.length != 6) {
      this.verifyErrors = [{ security_code: 'Invalid Code' }];
      return;
    }

    const action = attribute == 'email' ? 'verifyEmail' : 'verifyMobile';

    this.isVerifying = true;

    this.$store
      .dispatch('BusinessContact/' + action, {
        oid: this.verifyContactSync.object_id,
        totp: totp,
      })
      .then(() => {
        //success
        this.$store
          .dispatch('Business/fetch', {
            businessOid: this.business.object_id,
            config: {
              params: {
                expand: [
                  'business_contacts',
                  'business_addresses',
                  'billing_address',
                  'billing_contact',
                  'postal_address',
                  'primary_contact',
                  'director_contact',
                ],
              },
            },
          })
          .then(() => {
            this.isVerifying = false;
            this.showVerifyDialogSync = false;
            this.$store.commit('SET_SNACKBAR', {
              show: true,
              type: 'success',
              message: 'Verify successfully!',
            });
          });
      })
      .catch(({ response }) => {
        this.isVerifying = false;
        this.verifyErrors = response.data.error;
      });
  }

  get codeSync() {
    return this.verifyItem == 'mobile'
      ? this.verifyContactSync.mobile_totp
      : this.verifyContactSync.email_totp;
  }

  set codeSync(v) {
    if (this.verifyItem == 'mobile') {
      this.verifyContactSync.mobile_totp = v;
    } else {
      this.verifyContactSync.email_totp = v;
    }
  }

  isEmpty(v) {
    return _.isEmpty(v);
  }
}
